import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { AbstractControl, UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { IndexDbCacheService } from 'src/app/_core/de-query/index-db-cache.service';
import { SessionService } from 'src/app/_core/session.service';

@Component({
  selector: 'agr-clear-data-modal',
  templateUrl: './clear-data-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClearDataModalComponent {
  modal = inject(NgbActiveModal);
  private formBuilder = inject(UntypedFormBuilder);
  private indexDbCacheService = inject(IndexDbCacheService);
  private sessionService = inject(SessionService);

  form = this.formBuilder.group({
    clearLocalStorage: [false],
    clearIndexedDb: [true]
  });

  get clearLocalStorage(): AbstractControl {
    return this.form.get('clearLocalStorage');
  }
  get clearIndexedDb(): AbstractControl {
    return this.form.get('clearIndexedDb');
  }

  onSubmit(): void {
    if (this.clearLocalStorage.value) {
      this.sessionService.clear();
    }
    if (this.clearIndexedDb.value) {
      this.indexDbCacheService.clear();
    }
    this.modal.close();
  }
}
